import Swal from 'sweetalert2';
import _ from "lodash";
import moment from 'moment';

function updateInLocalStorage(key, value) {
  window.localStorage.setItem(key, value);
}

function removeInLocalStorage(key) {
  window.localStorage.removeItem(key);
}

function getLocalStorageItem(key) {
  return window.localStorage.getItem(key);
}

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  decimalCount = Math.abs(decimalCount);
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  const negativeSign = amount < 0 ? "-" : "";
  const i = parseInt(
    (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
  ).toString();
  const j = i.length > 3 ? i.length % 3 : 0;
  return (
    negativeSign +
    (j ? i.substr(0, j) + thousands : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
    (decimalCount
      ? decimal +
      Math.abs(amount - i)
        .toFixed(decimalCount)
        .slice(2)
      : "")
  );
}

function formatPhoneNumber(str) {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');
  if (cleaned.length > 10) {
    cleaned = cleaned.substring(0, 10);
  }

  //Check if the input is of correct length
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  };

  return '';
};

function getPaginationArray(
  total,
  activeNumber,
  showLength = 1,
  marginLength = 0
) {
  // this method will retrun an array that represent what should be showed in the pagination
  // example: total : 10. show count = 2 active number = 5 output:[3,4,5,6,7]
  if (total > 0) {
    let left = activeNumber - showLength >= 1 ? activeNumber - showLength : 1;
    let right =
      activeNumber + showLength <= total ? activeNumber + showLength : total;
    if (right - activeNumber < showLength) {
      // can expend on left
      const remain = showLength - (right - activeNumber);
      left = left - remain >= 1 ? left - remain : 1;
    } else if (activeNumber - left < showLength) {
      // can expend on right
      const remain = showLength - (activeNumber - left);
      right = right + remain <= total ? right + remain : total;
    }
    // expend left if not reached 0
    let leftExtend = [];
    if (left > marginLength + 2) {
      leftExtend = _.range(1, Math.min(marginLength + 2, left));
      leftExtend.push("...");
    } else if (left >= marginLength + 1) {
      leftExtend = _.range(1, Math.min(marginLength + 2, left));
    }
    let rightExtend = [];
    if (right < total - marginLength - 1) {
      rightExtend.push("...");
      rightExtend = rightExtend.concat(
        _.range(Math.max(total - marginLength - 1, right), total + 1)
      );
    } else if (right >= total - marginLength - 1 && right < total) {
      rightExtend = _.range(
        Math.max(total - marginLength, right + 1),
        total + 1
      );
    }
    const result = leftExtend
      .concat(_.range(left, right + 1))
      .concat(rightExtend);
    return result;
  }
  return [];
}

function getFixedLengthText(text = '', textLength = 40,) {
  if (!(text && typeof text === 'string' && text.length)) {
    return '';
  } else {
    return text.length > textLength ? text.substring(0, textLength - 3) + '...' : text;
  }
}

function formatTime(inputDate, timeFormat = 'MM/DD/YYYY') {
  if (typeof inputDate === 'string' || typeof inputDate === 'object') {
    let momentObj = moment(inputDate);
    if (momentObj.isValid()) {
      return momentObj.format(timeFormat);
    } else {
      return '';
    }
  } else {
    return '';
  }
}

function getGUID() {
  let u = Date.now().toString(16) + Math.random().toString(16) + '0'.repeat(16);
  return [u.substr(0, 8), u.substr(8, 4), '4000-8' + u.substr(13, 3), u.substr(16, 12)].join('-');
}

function functionExist(testObject) {
  if (testObject && typeof testObject === 'function') {
    return true;
  } else {
    return false;
  }
}

function DownloadBlobExcelFileWithContentDisposition(response, fileName) {
  try {
    var disposition = response.headers["content-disposition"];
    if (disposition && disposition.indexOf("attachment") !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches.length > 0 && matches[1]) {
        fileName = matches[1].replace(/['"]/g, "");
      }
    }
  } catch (error) {
    console.error(error);
  }
  var blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
  });
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = window.URL.createObjectURL(blob);
  link.target = "_blank";
  link.setAttribute("download", fileName);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function isValidMinneapolismnEmail(testTarget) {
  let myReg = /\b[\w\.-]+@minneapolismn\.gov\b/gi;
  return myReg.test(testTarget);
}

function isValidEmail(testTarget) {
  if (testTarget.includes('..')) {
    return false;
  }
  let myReg = /(?!^[.+'_-]*@.*$)(^[_\w\d+'-]+(\.[_\w\d+'-]*)*@[\w\d-]+(\.[\w\d-]+)*\.(([\d]{1,3})|([\w]{2,}))$)/;
  return myReg.test(testTarget);
}

function isValidPassword(testTarget) {
  let myReg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/gi;
  return myReg.test(testTarget);
}

function isValidPhone(testTarget) {
  let myReg = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  return myReg.test(testTarget);
}

function isValidUrl(urlString) {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
    "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};


function formatCamelText(input) {
  let result = input.replace(/([A-Z])/g, " $1");
  return result;
}

function scrollToPageTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function getUniqueId(length = 16) {
  return parseInt(Math.ceil(Math.random() * Date.now()).toPrecision(length).toString().replace(".", "")).toString();
}

function toastSuccessMessage(message) {
  Swal.fire({
    icon: "success",
    position: "top-end",
    title: "Success",
    text: message,
    timer: 5000,
    toast: true,
    timerProgressBar: true,
    showConfirmButton: false,
    showCancelButton: false,
  });
}

function uniqueId() {
  return Math.random().toString(36).substr(2, 9);
}

function DownloadBlobFileWithContentDisposition(response, fileName) {
  fileName = fileName !== undefined ? fileName : "attachment.pdf";
  try {
    var disposition = response.headers["content-disposition"];
    if (disposition) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches.length > 0 && matches[1])
        fileName = matches[1].replace(/['"]/g, "");
    }
  } catch (error) {
    console.error(error);
  }
  const blob = new Blob([response.data]);
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = window.URL.createObjectURL(blob);
  link.target = "_blank";
  link.setAttribute("download", fileName);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function getTotalCountFromHeader(response) {
  let headers = response.headers || {};
  let pagination = headers["x-pagination"] || null;
  if (typeof pagination === "string") {
    let parsedPagination = JSON.parse(pagination) || null;
    return (parsedPagination || {}).TotalCount;
  } else {
    return 0;
  }
}

function datagridPayloadRename(inputPayload) {
  let newPayload = _.cloneDeep(inputPayload);
  if (!!newPayload.recordsPerPage != null) {
    newPayload.PageSize = inputPayload.recordsPerPage;
    delete newPayload.recordsPerPage;
  }
  if (!!newPayload.pageNum != null) {
    newPayload.PageNumber = inputPayload.pageNum;
    delete newPayload.pageNum;
  }
  return newPayload;
}

function booleanToEnglish(booleanValue) {
  if (typeof booleanValue === 'boolean') {
    return booleanValue === true ? "Yes" : "No";
  } else {
    return "";
  }
}

function getResetPasswordParams(url) {
  if (typeof url === "string" && url.length > 0) {
    let indexOfFirstQ = url.indexOf("?");
    if (indexOfFirstQ !== -1) {
      let search = url.substring(indexOfFirstQ + 1);
      let indexOfFirstAnd = search.indexOf("&");
      if (indexOfFirstAnd !== -1) {
        return {
          email: search.substring(0, indexOfFirstAnd).replace("email=", ''),
          token: search.substring(indexOfFirstAnd + 1).replace("token=", ''),
        }
      }
    }
  }
  return null;
}

function formatAddress({ address, city, state, zip }) {
  let result = [];
  if (address != null) {
    result.push(address);
  }
  if (city != null) {
    result.push(`, ${city}`);
  }
  if (state != null) {
    result.push(`, ${state}`);
  }
  if (zip != null) {
    result.push(`, ${zip}`);
  }
  return result.join("");
}

function hasPrivilege(targetPrivilege, currentPrivileges) {
  let result = false;
  if (currentPrivileges && currentPrivileges.length > 0) {
    result =
      currentPrivileges.findIndex((item) => {
        return item === targetPrivilege;
      }) !== -1;
  }
  return result;
}

function hasOneOfPrivilege(targetPrivileges, currentPrivileges) {
  let result = false;
  if (currentPrivileges && currentPrivileges.length > 0) {
    result =
      currentPrivileges.findIndex((item) => {
        return targetPrivileges.findIndex((tp) => {
          return tp === item;
        }) !== -1;
      }) !== -1;
  }
  return result;
}

export const utils = {
  formatAddress,
  updateInLocalStorage,
  removeInLocalStorage,
  getLocalStorageItem,
  formatMoney,
  formatTime,
  getPaginationArray,
  getFixedLengthText,
  getGUID,
  functionExist,
  formatPhoneNumber,
  DownloadBlobFileWithContentDisposition,
  DownloadBlobExcelFileWithContentDisposition,
  isValidPhone,
  formatCamelText,
  scrollToPageTop,
  getUniqueId,
  toastSuccessMessage,
  uniqueId,
  getTotalCountFromHeader,
  datagridPayloadRename,
  booleanToEnglish,
  getResetPasswordParams,
  hasPrivilege,
  hasOneOfPrivilege,
  isValidUrl,
  isValidEmail,
  isValidMinneapolismnEmail,
  isValidPassword,
};